const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        const video = entry.target;
        video.src = video.dataset.lazySrc;
        observer.unobserve(video);
      }
    }
  },
  { rootMargin: '200px' }
);

function observeVideos(root = document) {
  root.querySelectorAll('video[data-lazy-src]:not([src])').forEach((video) => {
    observer.observe(video);
  });
}

observeVideos();

// Pick up dynamically added videos anywhere in the DOM
const mutationObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches?.('video[data-lazy-src]:not([src])')) {
        observer.observe(node);
      }
      node
        .querySelectorAll?.('video[data-lazy-src]:not([src])')
        .forEach((v) => {
          observer.observe(v);
        });
    }
  }
});
mutationObserver.observe(document.body, { childList: true, subtree: true });
